export const REGISTRATION_URL =
  "https://9fbeok0wbj.execute-api.ap-south-1.amazonaws.com/dev/email";
